import { useEffect, useMemo, useRef } from "react";
import { MapContainer, TileLayer, Marker, Circle, useMap, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icon paths for CRA builds
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function ClickHandler({ onPick }) {
  useMapEvents({
    click(e) { onPick(e.latlng.lat, e.latlng.lng); },
  });
  return null;
}

function Recenter({ lat, lng }) {
  const map = useMap();
  useEffect(() => {
    if (Number.isFinite(lat) && Number.isFinite(lng) && (lat !== 0 || lng !== 0)) {
      map.setView([lat, lng], Math.max(map.getZoom(), 17));
    }
    // eslint-disable-next-line
  }, [lat, lng]);
  return null;
}

export default function GeofenceMap({ latitude, longitude, radius, onPick }) {
  const lat = Number(latitude);
  const lng = Number(longitude);
  const r = Math.max(Number(radius) || 50, 5);
  const valid = Number.isFinite(lat) && Number.isFinite(lng) && (lat !== 0 || lng !== 0);

  const center = useMemo(
    () => (valid ? [lat, lng] : [12.9352, 77.6245]),
    [lat, lng, valid]
  );

  const markerRef = useRef(null);

  return (
    <div
      data-testid="geofence-map"
      className="h-64 w-full border border-border overflow-hidden"
    >
      <MapContainer
        center={center}
        zoom={valid ? 18 : 3}
        scrollWheelZoom
        style={{ height: "100%", width: "100%", background: "hsl(215 60% 8%)" }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap contributors &copy; CARTO'
          url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
        />
        {valid && (
          <>
            <Marker
              position={[lat, lng]}
              draggable
              ref={markerRef}
              eventHandlers={{
                dragend: () => {
                  const m = markerRef.current;
                  if (m) {
                    const p = m.getLatLng();
                    onPick(p.lat, p.lng);
                  }
                },
              }}
            />
            <Circle
              center={[lat, lng]}
              radius={r}
              pathOptions={{ color: "#fbbf24", fillColor: "#fbbf24", fillOpacity: 0.15, weight: 2 }}
            />
          </>
        )}
        <Recenter lat={lat} lng={lng} />
        <ClickHandler onPick={onPick} />
      </MapContainer>
    </div>
  );
}
